import { styleFromFontWeight } from "@redotech/redo-content-builder-common/brand-kit";
import CheckCircle from "@redotech/redo-icons/check-circle.svg";
import { Teaser as ITeaser } from "@redotech/redo-marketing-common/signup-form/signup-form";
import { Flex } from "@redotech/redo-web/flex";
import { memo } from "react";

export const BaseTeaser = memo(function Teaser({
  teaser,
  onClick,
}: {
  teaser: ITeaser;
  onClick: () => void;
}) {
  return (
    <Flex
      align="center"
      justify="space-between"
      onClick={onClick}
      pb="md"
      pl="xl"
      pr={teaser.iconVisible ? "3xl" : "xl"}
      pt="md"
      style={{
        backgroundColor: teaser.backgroundColor,
        borderRadius: teaser.cornerRadiusPx,
        color: teaser.textColor,
        fontFamily: teaser.fontFamily,
        fontSize: teaser.fontSizePx,
        fontWeight: styleFromFontWeight(teaser.fontWeight),
        borderWidth: teaser.borderStroke.weightPx,
        borderColor: teaser.borderStroke.color,
        borderStyle: "solid",
        pointerEvents: "auto",
        cursor: "pointer",
        zIndex: 1_000_000,
      }}
    >
      {teaser.iconVisible && (
        <CheckCircle style={{ height: "32px", width: "32px" }} />
      )}
      {teaser.text}
    </Flex>
  );
});
